import BossModel from '@/models/BossModel'
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Photo extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/gallery/photo';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetGalleryPhotos';


    static fields() {
        return {
            id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            rank: this.number(null).nullable(),
            website_widget_gallery_id: this.number(null).nullable(),
            public_image_id: this.number(null).nullable(),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
        }
    }

    /**
     *
     * @param sliderId
     * @returns {*}
     */
    static byWebsiteGallery(galleryId) {
        return this.all().filter(item => item.website_widget_gallery_id == galleryId);
    }

    /**
     *
     * @param sliderId
     * @returns {*}
     */
    static fetchByGalleryId(galleryId) {
        return this.api()
            .where('website_widget_gallery_id', galleryId)
            .orderBy('rank', 'asc')
            .with(['publicImage'])
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return PublicImage.find(this.public_image_id);
    }
}
